// @components/HighlightWords/index.tsx
import { Platform } from 'react-native';

import NativeHighlighter from '@components/HighlightWords/HighlightWords.native';
import WebHighlighter from '@components/HighlightWords/HighlightWords.web';

const Highlighter = Platform.select({
  web: WebHighlighter,
  default: NativeHighlighter,
});

export default Highlighter!;
